import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Modal from "./Modal";
import LeftSide from "./LeftSide";
import RightSide from "./RightSide";
import toast from "react-hot-toast";
import {
  fetchAllUsers,
  fetchChatList,
  fetchAllMessages,
  sendInvite,
  sendMessage,
  clearChat,
  clearConversation,
} from "../Reducer/apiCall";
import { setSelectedChat } from "../Reducer/chatReducer";
import socket from "../Utils/soket";
import { setAllNotification, setCount } from "../Reducer/notificationReducer";
import { DEFAULTIMAGEURL, IMAGEURL } from "../Utils/EndPoint";


const Dashboard = () => {
  const dispatch = useDispatch();
  const { allUser, chatList, selectedChat, allMessage, status, error } = useSelector((state) => state.Chat);
  const user = useSelector((state) => state.Auth.user);

  const [message, setMessage] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!user) return;
    socket.emit("setup", user._id);
    socket.on("connected", () => console.log("socket connected"));
  }, [user]);

  useEffect(() => {
    const handleNewMessage = (newMessage) => {
      try {
        if (user._id === newMessage.receiverId) {
          if (
            selectedChat?.otherUser?._id === newMessage?.receiverId ||
            selectedChat?.otherUser?._id === newMessage?.senderId?._id
          ) {
            dispatch(fetchAllMessages(newMessage.senderId._id));
          } else {
            dispatch(setCount(1));
            const payload = {
              firstName: newMessage.senderId.firstName,
              message: newMessage.message,
              createdAt: newMessage.createdAt,
              _id: newMessage?.conversationId,
            };
            dispatch(setAllNotification(payload));
            toast.custom((t) => (
              <div
                className={`${t.visible ? 'animate-enter' : 'animate-leave'
                  } max-w-md w-full bg-white shadow-lg rounded-lg pointer-events-auto flex ring-1 ring-black ring-opacity-5`}
              >
                <div className="flex-1 w-0 p-4">
                  <div className="flex items-start">
                    <div className="flex-shrink-0 pt-0.5">

                      <img
                        className="h-10 w-10 rounded-full"

                        src={newMessage.image
                          ? `${IMAGEURL}/${newMessage.image}`
                          : DEFAULTIMAGEURL}
                        alt=""
                      />
                    </div>
                    <div className="ml-3 flex-1">
                      <p className="text-sm font-medium text-gray-900">
                        New Message From: {newMessage.senderId.firstName}
                      </p>
                      <p className="mt-1 text-sm text-gray-500">
                        {newMessage.message}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="flex border-l border-gray-200">

                  <button
                    onClick={() => toast.dismiss(t.id)}
                    className="w-full border border-transparent rounded-none rounded-r-lg p-4 flex items-center justify-center text-sm font-medium text-indigo-600 hover:text-indigo-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                  >
                    Close
                  </button>
                </div>
              </div>
            ), { duration: 5000 })

          }
          setTimeout(() => {
            dispatch(fetchChatList());
          }, 500);
        }
      } catch (error) {
        toast.error(error?.Message);
      }
    };

    socket.on("message received", handleNewMessage);

    return () => {
      socket.off("message received", handleNewMessage);
    };
  }, [socket, selectedChat, user._id, dispatch]);

  useEffect(() => {
    dispatch(fetchAllUsers());
    dispatch(fetchChatList());
  }, [dispatch]);

  useEffect(() => {
    if (status === "failed" && error) {
      toast.error(error);
    }
  }, [status, error]);

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleSendInvite = async (userdata) => {
    dispatch(sendInvite(userdata._id))
      .then(() => {
        toast.success("Chat added to your list!");
        socket.emit("chat created", user._id, userdata._id);
      })
      .catch((error) => {
        toast.error(error?.message);
      });
    toggleModal();
  };

  const handleSendMessage = () => {
    if (message.trim() === "") return;
    dispatch(
      sendMessage({
        conversationId: selectedChat._id,
        senderId: user._id,
        receiverId: selectedChat.otherUser._id,
        message,
      })
    );

    setTimeout(() => {
      dispatch(fetchChatList());
    }, 500);

    const newMessage = {
      senderId: user,
      receiverId: selectedChat.otherUser._id,
      message: message.trim(),
      createdAt: new Date(),
      conversationId: selectedChat._id,
      image: selectedChat?.otherUser?.image,
    };

    socket.emit("new message", newMessage);
    setMessage("");
  };

  const handleSelectChat = useCallback(
    (chat) => {
      dispatch(fetchAllMessages(chat.otherUser._id));
      dispatch(setSelectedChat(chat));
      socket.emit("join chat", chat._id);
    },
    [dispatch, socket]
  );


  const handleClearChat = async () => {
    const payload = {
      senderId: user._id,
      receiverId: selectedChat?.otherUser?._id,
    };
    if (window.confirm("Are you sure you want to clear chat?")) {
      dispatch(clearChat(payload));
      socket.emit("clear chat", selectedChat?.otherUser?._id, user.firstName);
    }
  };

  const handleClearConversation = async (chat) => {
    if (window.confirm("Are you sure you want to clear the conversation?")) {
      await dispatch(clearConversation(chat._id));
      await dispatch(setSelectedChat(null));
      socket.emit("clear conversation", chat);
    }
  };

  return (
    <div className="flex w-full border-slate-500 p-3 border rounded-sm shadow-md shadow-black">

      <div className="relative left side border rounded-sm flex flex-col w-1/2 px-4 gap-1 py-2 overflow-y-auto overflow-hidden scroll-style h-[70vh]">
        {isModalOpen && (
          <Modal closeModal={toggleModal} user={allUser} handleSendInvite={handleSendInvite} />
        )}
        <LeftSide
          toggleModal={toggleModal}
          chatList={chatList}
          handleSelectChat={handleSelectChat}
          clearConversation={handleClearConversation}
        />
      </div>
      <RightSide
        selectedChat={selectedChat}
        setSelectedChat={() => dispatch(setSelectedChat(null))}
        message={message}
        setMessage={setMessage}
        allMessage={allMessage}
        handleSendMessage={handleSendMessage}
        clearChat={handleClearChat}
      />
    </div>
  );
};

export default Dashboard;
